'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddressConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressConstants = exports.AddressConstants = (0, _keymirror2.default)({
    ADDRESSES_LOAD: null,
    ADDRESSES_LOAD_SUCCESS: null,
    ADDRESSES_LOAD_FAIL: null,
    ADDRESS_ADD: null,
    ADDRESS_ADD_SUCCESS: null,
    ADDRESS_ADD_FAIL: null,
    ADDRESS_UPDATE: null,
    ADDRESS_UPDATE_SUCCESS: null,
    ADDRESS_UPDATE_FAIL: null,
    ADDRESS_DELETE: null,
    ADDRESS_DELETE_SUCCESS: null,
    ADDRESS_DELETE_FAIL: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/address.js
// module id = 1864
// module chunks = 0